import { TableTemplate } from "components/templates/default/table/TableTemplate";
import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import * as s from "./CvvStyled";
import BigButton from "components/atoms/buttons/BigButton";
import SearchInput, {
  ClickSearch,
} from "components/atoms/input/search/SearchInput";
import { CheckInput } from "styles/ModalCommonStyled";
import { Option } from "utils/options";
import CvvCamera from "./CvvCamera";
import CvvLabel from "./CvvLabel";
import CheckInclude from "components/blocks/subheader/sub/CheckInclude";
import StorageLabel from "components/blocks/storage/StorageLabel";
import { StorageWrapper } from "components/templates/default/table/TableTemplateStyled";
import * as mediaQuery from "components/MediaQuery";
import {
  CvvCheckNowRequestPartial,
  CVVPairItem,
  CvvQueryString,
  CvvViewListItem,
  DayNightItem,
} from "api/interfaces/reportInterface.interface";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
// import { checkCVVError } from "utils/functions";
import NoData from "components/templates/nopage/NoData";

import RBACWrapper from "components/blocks/function/RBACWrapper";
import SelectComponent from "components/atoms/select/SelectComponent";
import AntdPagination from "components/blocks/pagination/AntdPagination";
import { useMenu } from "hook/useMenu";

import { BsCheck } from "react-icons/bs";
import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";
import { useAppSelector } from "redux/hooks";
import { checkEmpty } from "utils/functions";
type Props = {
  title: string | undefined;
  recorderList: Option[];
  recorderListIsFetching: boolean;
  cvvList: CvvViewListItem;
  selectFilterRecorder: string;
  onChangeFilterRecorder: (value: string) => void;
  onClickSearch: ClickSearch;
  cvvQueryInfo: CvvQueryString;
  onChangePage: (page: number, totalRows: number) => void;
  selectedAccount: ProfileAccountInfo;
  onChangeIsCvv: (checked: boolean) => void;
  onClickUpdate: (data: DayNightItem, pairItem: CVVPairItem) => Promise<void>;
  onClickUpdateAll: () => void;
  onClickCheckNow: (payload: CvvCheckNowRequestPartial) => Promise<void>;
  listCount: number;
  disabledCheckNow: boolean;
  showNotifyAutoUpdate: boolean;
  onClickNotifyAutoUpdate: () => void;
  // setIsCvvOpen: any;
};

export default function CvvPresenter(props: Props): JSX.Element {
  const { menuNavigation } = useMenu({});
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const infoHeaders = [
    {
      title: "Cameras",
      content: (
        <Text bold fontSize={18}>
          {props.cvvList.usageCameras}/{props.cvvList.totalCameras} CH
        </Text>
      ),
    },
    {
      title: "CVV",
      content: (
        <Text bold fontSize={18}>
          <strong>
            Alert:{" "}
            {props.cvvList.warningCameras !== undefined
              ? props.cvvList.warningCameras
              : 0}
          </strong>{" "}
          / {props.cvvList.usageCameras}
        </Text>
      ),
    },
    {
      title: "Location",
      content: (
        <Text bold fontSize={18}>
          {props?.cvvList?.location?.location
            ? props?.cvvList?.location?.location
            : "-"}
        </Text>
      ),
    },
  ];

  const sub = (
    <StorageWrapper>
      <StorageLabel />
    </StorageWrapper>
  );

  const titleComponent = [
    {
      label: "Report List",
      onClick: () => menuNavigation({ to: "/reports" }),
    },
    {
      label: props.title,
    },
  ];

  // let isError = false;
  // if (props.currentPairitem !== undefined && props.currentPairitem !== null) {
  //   isError = checkCVVError(props.currentPairitem.eventThumbnail);
  // }
  return (
    <>
      <TableTemplate noSearch buttons={sub} titleComponent={titleComponent}>
        <mediaQuery.Mobile>
          <s.HeaderRight>
            <div className="select-wrapper">
              <SelectComponent
                options={props.recorderList}
                loading={props.recorderListIsFetching}
                value={
                  props.selectFilterRecorder !== undefined &&
                  props.selectFilterRecorder !== ""
                    ? props.recorderList.find(
                        (option) => option.value === props.selectFilterRecorder
                      )
                    : props.recorderList[0]
                }
                onChange={props.onChangeFilterRecorder}
                data-testid="reports-view-cvv-selects-change-filter-recorder"
              />
            </div>
            <div className="search-input">
              <SearchInput
                placeholder="Search"
                onClickSearch={props.onClickSearch}
              />
            </div>
          </s.HeaderRight>
        </mediaQuery.Mobile>
        <s.Header>
          <s.HeaderInfo>
            <CheckInput>
              {props.cvvList.isWarning !== undefined &&
                props.cvvList.isWarning && (
                  <CvvLabel
                    status={props.cvvList.isWarning ? "warning" : "normal"}
                  />
                )}

              <Text fontSize={18} bold>
                {props.cvvList.date !== undefined ? props.cvvList.date : ""}
              </Text>
            </CheckInput>
            <CheckInclude
              label="Detect CVV only"
              onChange={props.onChangeIsCvv}
              isCVV
            />
          </s.HeaderInfo>
          <mediaQuery.Default>
            <s.HeaderRight>
              <div className="select-wrapper">
                <SelectComponent
                  options={props.recorderList}
                  loading={props.recorderListIsFetching}
                  value={
                    props.selectFilterRecorder !== undefined &&
                    props.selectFilterRecorder !== ""
                      ? props.recorderList.find(
                          (option) =>
                            option.value === props.selectFilterRecorder
                        )
                      : props.recorderList[0]
                  }
                  onChange={props.onChangeFilterRecorder}
                  data-testid="reports-view-cvv-selects-change-filter-recorder-2"
                />
              </div>
              <div className="search-input">
                <SearchInput
                  placeholder="Search"
                  onClickSearch={props.onClickSearch}
                />
              </div>
            </s.HeaderRight>
          </mediaQuery.Default>
        </s.Header>
        <s.HeaderMessageWrapper>
          <span>
            <BsCheck /> Occasional false detections may occur.
          </span>
          <span>
            <BsCheck />
            Accuracy improves over time as our CVV Ai learns the scene.
          </span>
        </s.HeaderMessageWrapper>
        <s.Container isEmpty={checkEmpty(props.cvvList.cameras)}>
          {!checkEmpty(props.cvvList.cameras) ? (
            <>
              <s.ContentHeader>
                <s.ContentInfo>
                  <mediaQuery.Default>
                    {infoHeaders.map((item, idx) => (
                      <s.ContentInfoItem key={item.title}>
                        <Text className="content-info-item-title">
                          {item.title}
                        </Text>
                        {item.content}
                      </s.ContentInfoItem>
                    ))}
                  </mediaQuery.Default>
                  <mediaQuery.Mobile>
                    {infoHeaders.map(
                      (item, idx) =>
                        idx !== 2 && (
                          <s.ContentInfoItem key={item.title}>
                            <Text color={`${COLORS.WHITE}50`}>
                              {item.title}
                            </Text>
                            {item.content}
                          </s.ContentInfoItem>
                        )
                    )}
                  </mediaQuery.Mobile>
                </s.ContentInfo>

                <mediaQuery.Mobile>
                  <s.ContentInfoItem>
                    <Text color={`${COLORS.WHITE}50`}>
                      {infoHeaders[2].title}
                    </Text>
                    {infoHeaders[2].content}
                  </s.ContentInfoItem>
                </mediaQuery.Mobile>
                {selectedAccount.isAdminGroup && (
                  <RBACWrapper requiredPermissions="manageReportRules">
                    <BigButton
                      buttonType="cancel"
                      label="Update Reference"
                      onClickBtn={() => props.onClickUpdateAll()}
                      data-testid="reports-view-cvv-button-click-update-all"
                    />
                  </RBACWrapper>
                )}
              </s.ContentHeader>
              <ul>
                {props.cvvList.cameras.map((data) => (
                  <CvvCamera
                    key={data.id}
                    recorderType={props.cvvList.recorderType}
                    timezone={props.cvvList.timezone}
                    timezoneOffset={props.cvvList.offset}
                    selectedAccount={props.selectedAccount}
                    data={data}
                    onClickUpdate={props.onClickUpdate}
                    onClickCheckNow={props.onClickCheckNow}
                    disabledCheckNow={props.disabledCheckNow}
                    selectFilterRecorder={props.selectFilterRecorder}
                    recorderList={props.recorderList}
                    isProtected={data.covert}
                  />
                ))}
              </ul>
            </>
          ) : (
            <NoData />
          )}
        </s.Container>

        <AntdPagination
          rowsPerPage={props.cvvQueryInfo.pageLimit}
          rowCount={props.listCount}
          onChangePage={props.onChangePage}
          currentPage={props.cvvQueryInfo.pageNum}
        />
      </TableTemplate>
      {props.showNotifyAutoUpdate && (
        <SmallPopupTemplate
          title="Scheduled Update Notice"
          confirmLabel="OK"
          disableClose={true}
          onClick={props.onClickNotifyAutoUpdate}
          data-testid="reports-view-cvv-small-popup-template-click-notify-auto-update"
        >
          <s.NotifyAutoUpdateContent>
            <p>You have successfully set the reference image.</p>
            <p>
              Please note that the system will automatically update the
              reference image at the next scheduled time (either 2:00 AM or 2:00
              PM local server time), overriding this manual setting.
            </p>
          </s.NotifyAutoUpdateContent>
        </SmallPopupTemplate>
      )}

      {/* {props.isCvvOpen &&
          props.currentCvv !== null &&
          props.currentPairitem !== null && (
            <BigPopupNoHeaderTemplate>
              <s.ModalHeader>
                <s.ModalInfo>
                  <s.CameraHeaderItem>
                    <Text color={`${COLORS.WHITE}50`}>Recorders</Text>
                    <Text bold>
                      {props.selectFilterRecorder !== undefined &&
                      props.selectFilterRecorder !== ""
                        ? props.recorderList.find(
                            (option) =>
                              option.value === props.selectFilterRecorder
                          )?.label
                        : ""}
                    </Text>
                  </s.CameraHeaderItem>
                   <s.CameraHeaderItem>
                    <Text color={`${COLORS.WHITE}50`}>Camera</Text>
                    <Text
                      bold
                    >{`${props.currentCvv.name} #${props.currentCvv.channel}`}</Text>
                  </s.CameraHeaderItem>
                   <s.CameraHeaderItem>
                    <Text color={`${COLORS.WHITE}50`}>Date / Time</Text>
                    <Text bold>
                      {getRecorderTimeFormat(
                        props.currentPairitem.eventThumbnail.date,
                        props.selectedAccount,
                        props.cvvList.timezone,
                        true,
                        true
                      )}
                    </Text>
                  </s.CameraHeaderItem>
                </s.ModalInfo>
                 <button onClick={() => props.setIsCvvOpen(false)}>
                  <img alt="close button" src={CLOSE_ICON} />
                </button>
              </s.ModalHeader>
              <s.CvvContainer isError={isError}>
                {isError && (
                  <s.CvvHeader>
                    <img src={WARNIN_CIRCLE_ICON} alt="warning circle icon" />
                    CVV has detected obstructions blocking the camera's view. For
                    optimal viewing quality, please remove them as soon as
                    possible.
                  </s.CvvHeader>
                )}
                 <s.CvvThumbnailWrapper>
                  <s.ErrorWrapper>
                    {cvvEvent.map((evt, index) => {
                      if (
                        props.currentCvv !== null &&
                        props.currentCvv.day.eventThumbnail[evt] === true
                      ) {
                        return <SmallLabel label={evt} color={COLORS.RED} />;
                      } else return null;
                    })}
                  </s.ErrorWrapper>
                  <CVVThumbnail
                    videoLoss={false}
                    thumbnailUrl={`${
                      props.currentPairitem.eventThumbnail.url
                    }?v=${Date.now()}`}
                  />
                </s.CvvThumbnailWrapper>
              </s.CvvContainer>
            </BigPopupNoHeaderTemplate>
          )} */}
    </>
  );
}
